import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ITableServerResponseFilter } from 'src/app/common/interfaces/table/table-server-filter-response.interface';
import { ITableServerFilter } from 'src/app/common/interfaces/table/table-server-filter.inteface';
import { lastValueFrom } from 'rxjs';
import { AbstractRtpTransactionService } from '../abstraction/abstract.rtp-transaction.service';
import {
  ICamt035AcwpOption,
  ICamt035AcwpUpdateRequest,
} from '../../interfaces/camt035/camt035-acwp.interface';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { WebMessageStatus } from 'src/app/common/constants/webmessage-status.constants';

@Injectable({
  providedIn: 'root',
})
export class MockRtpTransactionService extends AbstractRtpTransactionService {
  private tableFilterJson = 'assets/mocks/rtp/transaction/tableFilter.json';
  private getByIdCreditJson = 'assets/mocks/rtp/transaction/getByIdCredit.json';
  private getByIdCreditAcwpJson = 'assets/mocks/rtp/transaction/getByIdCreditAcwp.json';
  private getByIdDebitJson = 'assets/mocks/rtp/transaction/getByIdDebit.json';
  private getReturnByIdJson = 'assets/mocks/rtp/returnlist/getReturnPaymentById.json';
  private getAcwpOptionsJson = 'assets/mocks/rtp/camt035/acwpOptions.json';
  private readonly acwpMessageId = '2025011771196035021230430742C8EECDP';
  constructor(private http: HttpClient) {
    super();
  }

  tableFilter(filter: ITableServerFilter): Promise<ITableServerResponseFilter | undefined> {
    return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.tableFilterJson));
  }

  tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    throw new Error('Method not implemented.');
  }

  tableExportExcel(filter: ITableServerFilter): Promise<Blob | undefined> {
    throw new Error('Method not implemented.');
  }

  async getById(messageId: string, type: string): Promise<any> {
    if (type === 'Debit') {
      return lastValueFrom(this.http.get<any>(this.getByIdDebitJson));
    }
    if (messageId === this.acwpMessageId) {
      return lastValueFrom(this.http.get<any>(this.getByIdCreditAcwpJson));
    }
    return lastValueFrom(this.http.get<any>(this.getByIdCreditJson));
  }

  getReturnById(messageId: string, type: string): Promise<any> {
    return lastValueFrom(this.http.get<any>(this.getReturnByIdJson));
  }

  getAcwpOptions(): Promise<ICamt035AcwpOption[] | undefined> {
    return lastValueFrom(this.http.get<ICamt035AcwpOption[]>(this.getAcwpOptionsJson));
  }

  updateAcwpStatus(
    paymentInstructionId: string,
    request: ICamt035AcwpUpdateRequest
  ): Promise<IWebMessage | undefined> {
    return Promise.resolve({
      status: WebMessageStatus.Success,
      message: 'Posting status updated successfully.',
      object: { camt035AcwpStatus: request.acwpStatus },
    } as IWebMessage);
  }
}
